import BaseModelAPI from '../BaseModelAPI';

export default class ControlCardType extends BaseModelAPI {
	static entity = 'controlcardtype';
	static entityName = 'controlcardtype';

	constructor(){

	/*APP_MODEL_DEFINITION*/
			this.id = '';
			this.code = '';
			this.name = '';
			this.noDoc = '';
			this.isFromUpload = false;
			this.isSavedToBackend = true;
			this.uploadValidationMessage = '';
			this.uploadValidationStatus = '';
	/*END_APP_MODEL_DEFINITION*/
	}

}